import downloadCsv from './csv';
import downloadPdf from './pdf';
import downloadExcel from './excel';
import { normalizeDateMonth } from '../date';
import { ALL_ALA_LEVELS_LABEL, MAX_ALA_LEVEL } from '../constants';

const downloadFile = (type, items, {
  columns, fileName, title, fontSize,
}) => {
  const headers = columns.map(item => item.header);
  const data = items.map(item => columns.map(({ key = '' }) => {
    if (key === 'alaLevels') {
      if (item[key].length === MAX_ALA_LEVEL) {
        return ALL_ALA_LEVELS_LABEL;
      }
      return item[key].map(ala => `ALA${ala}`).join(', ');
    }
    if (key === 'alaLevel' && item[key] === -1) {
      return 'ALA fail';
    }
    if ((key === 'alaLevel' || key === 'autoApprovalAlaLevel') && item[key]) {
      return `ALA${item[key]}`;
    }
    if ((key === 'statusUpdateDate') && item[key]) {
      return normalizeDateMonth(item[key]);
    }
    if ((key === 'lastInvoiceUpdate') && item[key]) {
      return normalizeDateMonth(item[key]);
    }

    if (key === 'mailClass' && item[key]) {
      return item[key].map(mailClass => mailClass.label).join(', ');
    }

    const value = key.split('.').reduce((combined, part) => combined[part], item);

    return value === undefined ? '' : value;
  }));

  switch (type) {
  case 'pdf':
    {
      const options = {
        title, headers, rows: data, fileName, fontSize,
      };

      downloadPdf(options);
    }
    break;
  case 'excel':
    downloadExcel(title, fileName, columns, data);
    break;
  default:
    downloadCsv(fileName, headers, data);
    break;
  }
};

export {
  downloadCsv, downloadPdf, downloadExcel, downloadFile,
};
